import axios from '@/axios.js'

export default {
    getPhotos: async (resortUuid, parameters) => {
        try {
            const response = await axios.editorapi.get(`v4/resorts/${resortUuid}/photos`, { params: parameters })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    exportPhotos: async (resortUuid, parameters) => {
        try {
            const response = await axios.editorapi.get(`v4/resorts/${resortUuid}/export/photos`, { params: parameters })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
}
